import React, { useEffect, useState } from "react";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import AllAcountsSection from "../../Components/AllAccountsSection/AllAcountsSection";
import { AiFillCaretRight, AiOutlineArrowDown, AiOutlineArrowRight, AiOutlineArrowUp } from "react-icons/ai";
import SavePlusAccountComponent from "../../Components/SavePlusAccount/SavePlusAccountComponent";
import ContainsArea from "../../Components/ContainsArea/ContainsArea";

const IZBFlexiFarewellFuneralPlan = () => {
  const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-home-loan-banner.png";
  const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/FlexiFarewellFuneralPlan.png";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const accountContent = "";

  
  const [openIndex, setOpenIndex] = useState(null);


  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const accordionData = [
    {
        title: "Eligibility",
        content: [
          "The INDO Smart Child is a life policy designed for Indo Zambia Bank individual customers who would like to make provision for their children’s future school fees. An individual needs to have an account with the bank in order to be able to buy this policy.",
        ],
    },
    {
      title: "Features/benefits",
      content: [
        "Handsome Maturity Benefit",
        "Maturity Bonus",
        "Death Benefit",
        "Waiver Of Premium on Death, Permanent Disability & Critical Illness",
        "Adequate Paid-Up Value",
        "Inflation Protection Benefit",
        "Guaranteed Surrender Value",
      ],
    },
    {
      title: "Conditions and Requirements",
      content: [
        "Policy Terms-Minimum term 5 years, Max 20",
        "Age Range(Policy holder)-Minimum entry age 18, Max 60",
        "Age Range(Beneficiaries)Max Child Age 16, Min 1",
        "Policy Fee K20.00",
        "Lapsation – policy lapses after 3 months of missed premiums. The policy can be reinstated withing 12 months of lapsation",
        "Assignments & Loans – N/A. Policy can not be used as collateral for loans",
        "Cancellation Calculated by percentage",
      ],
    },
    {
      title: "How to Apply",
      content: ['To apply now, email <a href="mailto:bancassurance@izb.co.zm">bancassurance@izb.co.zm</a> or call <a href="tel:8002">8002</a>'],
    }
  ];

  return (
    <>
       <section className="HouseOwnersInsuranceSection">
        <Breadcrumb Heading="IZB Flexi Farewell Funeral Plan" img={BackgroundBrundcrumb} show={true} btnTxt="Apply Now" />
       </section>

       <SavePlusAccountComponent heading="IZB Flexi Farewell Funeral Plan" subHeading="Know About" btnTxt="Apply Now" content={accountContent} img={img1} logo={true} />
       {/* <ContainsArea /> */}

        <section>
            <div className="container">
            <div className="row">
                <div className="col-xl-12 justify-content-center">
                <div className="faq-style1__content">
                    <ul className="accordion-box custom-accordion-box custom-accordion-box-mt mt-2" style={{paddingBottom: "50px"}}>
                             <li className={`accordion block ${openIndex === 0 ? "active-block" : ""}`}>
                                <div className={`acc-btn  ${openIndex === 0 ? "active" : ""}`} 
                                     style={{ backgroundColor: "#9E1B1E", backgroundSize: "20px" }}
                                     onClick={() => handleToggle(0)}>
                                        <div className="icon-outer text-white">
                                             {openIndex === 0 ? <AiOutlineArrowRight /> :  <AiOutlineArrowRight />}
                                        </div>
                                        <h3 className="text-white">Eligibility</h3>
                                </div>
                                {openIndex === 0 && (
                                    <div className={`acc-content ${openIndex === 0 ? "current" : ""} px-5`}>
                                        <ul className="first-list">
                                            <li><AiFillCaretRight className="me-1 accordion-icon" /> <p>The INDO Flexi Farewell Funeral Plan is a special life insurance policy designed for Indo Zambia Bank individual customers that  allows flexible payment of risk premiums for funeral expenses for the policy holder and all listed family members/beneficiaries. An individual needs to have an account with the bank in order to be able to buy this policy.</p></li>
                                        </ul>
                                    </div>
                                )}
                            </li>

                            <li className={`accordion block ${openIndex === 1 ? "active-block" : ""}`}>
                                <div className={`acc-btn  ${openIndex === 1 ? "active" : ""}`} 
                                     style={{ backgroundColor: "#9E1B1E", backgroundSize: "20px" }}
                                     onClick={() => handleToggle(1)}>
                                        <div className="icon-outer text-white">
                                             {openIndex === 1 ? <AiOutlineArrowRight /> :  <AiOutlineArrowRight />}
                                        </div>
                                        <h3 className="text-white">Features/benefits</h3>
                                </div>
                                {openIndex === 1 && (
                                    <div className={`acc-content ${openIndex === 1 ? "current" : ""} px-5`}>
                                        <ul>
                                            <li><AiFillCaretRight className="me-1 accordion-icon" /><p>Funeral Benefit - as per selected option</p></li>
                                            <li><AiFillCaretRight className="me-1 accordion-icon" /><p>Accidental Death - for policyholder & Spouse</p></li>
                                            <li><AiFillCaretRight className="me-1 accordion-icon" /><p>No-claim Cashback - 10% of 5 years risk premiums</p></li>
                                            {/* <li><AiFillCaretRight className="me-1 accordion-icon" />Hospital Cash - up to 5% of Sum Assured each year (=/<3days)</li> */}
                                            <li><AiFillCaretRight className="me-1 accordion-icon" />Hospital Cash - up to 5% of Sum Assured each year (≤ 3 days)</li>
                                            <li><AiFillCaretRight className="me-1 accordion-icon" /><p>Loyalty Benefit - 5% of Sum Assured after each five years</p></li>
                                            <li><AiFillCaretRight className="me-1 accordion-icon" /><p>Waiver of Premium - on death of Policyholder</p></li>
                                            <li><AiFillCaretRight className="me-1 accordion-icon" /><p>Return of Premium - payback for death during waiting Period</p></li>
                                            <li><AiFillCaretRight className="me-1 accordion-icon" /><p>Flexible premiums - 6 months rolling Non-Lapse cover</p></li>
                                            <li><AiFillCaretRight className="me-1 accordion-icon" /><p>Different packages to suit varying individual needs</p></li>
                                        </ul>
                                    </div>
                                )}
                            </li>

                            <li className={`accordion block ${openIndex === 2 ? "active-block" : ""}`}>
                                <div className={`acc-btn  ${openIndex === 2 ? "active" : ""}`} 
                                     style={{ backgroundColor: "#9E1B1E", backgroundSize: "20px" }}
                                     onClick={() => handleToggle(2)}>
                                        <div className="icon-outer text-white">       
                                             {openIndex === 2 ? <AiOutlineArrowRight /> :  <AiOutlineArrowRight />}
                                        </div>
                                        <h3 className="text-white">Conditions and Requirements</h3>
                                </div>
                                {openIndex === 2 && (
                                    <div className={`acc-content ${openIndex === 2 ? "current" : ""} px-5`}>
                                        <ul>      
                                            <li><AiFillCaretRight className="me-1 accordion-icon" /><p>The minimum and maximum age at entry is as follows;</p></li>
                                                <ul className="submenu-level-2">
                                                    <li><AiFillCaretRight className="me-1 accordion-icon" /><p>Min 18 years, Max 60 years for policy holder and spouse</p></li>
                                                    <li><AiFillCaretRight className="me-1 accordion-icon" /><p>Min 21 and Max  75 for extended family members</p></li>
                                                    <li><AiFillCaretRight className="me-1 accordion-icon" /><p>Minimum 1 and Max 21 age next birthday for children</p></li>
                                                </ul>
                                            <li><AiFillCaretRight className="me-1 accordion-icon" /><p>Policy Term is 10, 15, or 20 years only </p></li>
                                            <li><AiFillCaretRight className="me-1 accordion-icon" /><p>Covered lives should be resident in Zambia at time of application</p></li>
                                            <li><AiFillCaretRight className="me-1 accordion-icon" /><p>K20 Policy fee</p></li>
                                            <li><AiFillCaretRight className="me-1 accordion-icon" /><p>After initial qualification of 6 months (waiting period), policy never lapses</p></li>
                                            <li><AiFillCaretRight className="me-1 accordion-icon" /><p>Assignments & Loans N/A- Policy cannot be used as collateral for loans</p></li>
                                        </ul>
                                    </div>
                                )}
                            </li>

                            <li className={`accordion block ${openIndex === 3 ? "active-block" : ""}`}>
                                <div className={`acc-btn  ${openIndex === 3 ? "active" : ""}`} 
                                     style={{ backgroundColor: "#9E1B1E", backgroundSize: "20px" }}
                                     onClick={() => handleToggle(3)}>
                                        <div className="icon-outer text-white">
                                             {openIndex === 3 ? <AiOutlineArrowRight /> :  <AiOutlineArrowRight />}
                                        </div>
                                        <h3 className="text-white">How to Apply</h3>
                                </div>
                                {openIndex === 3 && (
                                    <div className={`acc-content ${openIndex === 3 ? "current" : ""} px-5`}>
                                        <p>
                                          <AiFillCaretRight className="me-1 accordion-icon" />
                                          <span className="mt-1">
                                            To apply now, email <a href="mailto:bancassurance@izb.co.zm">bancassurance@izb.co.zm</a> or call <a href="tel:8002">8002</a>
                                          </span>
                                        </p>
                                    </div>
                                )}
                            </li>
                    
                    </ul>
                </div>
                </div>
            </div>
            </div>
        </section>

       <AllAcountsSection />
    </>
  );
};

export default IZBFlexiFarewellFuneralPlan;